import {
  Box,
  Button,
  Flex,
  HStack,
  IconButton,
  Input,
  Text,
  Tooltip,
  useDisclosure,
  useToast
} from "@chakra-ui/react";

import {
  FiEdit,
  FiSearch,
  FiTrash2,
  FiX
} from "react-icons/fi";

import {
  useEffect,
  useMemo,
  useState
} from "react";

import DataTable from "react-data-table-component";

import FormModal from "./FormModal";

import ContentCard from "../../components/common/ContentCard";

import {
  PageHeader
} from "../../components/common/PageHeader";

import {
  LiderancaService
} from "../../services/lideranca.service";

export default function ListPage() {

  const toast = useToast();

  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclosure();

  const [rows, setRows] =
    useState<any[]>([]);

  const [editing, setEditing] =
    useState<any>(null);

  const [loading, setLoading] =
    useState(false);

  const [numeroFilter, setNumeroFilter] =
    useState("");

  const [nomeFilter, setNomeFilter] =
    useState("");

  const [cpfFilter, setCpfFilter] =
    useState("");

  const [showNumero, setShowNumero] =
    useState(false);

  const [showNome, setShowNome] =
    useState(false);

  const [showCpf, setShowCpf] =
    useState(false);

  async function loadData() {

    try {

      setLoading(true);

      const data =
        await LiderancaService
          .findAll();

      setRows(data);

    } catch {

      toast({
        title:
          "Erro ao carregar lideranças",
        status: "error"
      });

    } finally {

      setLoading(false);
    }
  }

  useEffect(() => {

    loadData();

  }, []);

  async function handleSave(
    data: any
  ) {

    try {

      if (editing) {

        await LiderancaService
          .update(
            editing.id,
            data
          );

      } else {

        await LiderancaService
          .create(
            data
          );
      }

      toast({
        title:
          "Registro salvo com sucesso",
        status: "success"
      });

      onClose();

      setEditing(null);

      loadData();

    } catch (error: any) {

      const message =
        error.response?.data?.error ||
        error.message ||
        "Erro ao salvar";

      toast({
        title: message,
        status: "error"
      });
    }
  }

  // async function handleDelete(
  //   id: number
  // ) {

  //   const confirmar =
  //     confirm(
  //       "Deseja realmente excluir esta liderança?"
  //     );

  //   if (!confirmar)
  //     return;

  //   try {

  //     await LiderancaService
  //       .delete(id);

  //     toast({
  //       title:
  //         "Registro excluído",
  //       status: "success"
  //     });

  //     loadData();

  //   } catch (error: any) {
  //     const message =
  //       error.response?.data?.error ||
  //       error.message ||
  //       "Erro ao excluir";

  //     toast({
  //       title: message,
  //       status: "error"
  //     });
  //   }
  // }

  async function handleDelete(id: number) {
    console.log("Iniciando exclusão", id);

    const confirmar = confirm("Deseja realmente excluir esta liderança?");

    if (!confirmar) return;

    try {
      console.log("Chamando service...");

      const response = await LiderancaService.delete(id);

      console.log("Resposta:", response);

      toast({
        title: "Registro excluído",
        status: "success",
      });

      loadData();

    } catch (error: any) {
      console.error("ERRO COMPLETO:", error);
      console.error("response:", error.response);
      console.error("request:", error.request);
      console.error("message:", error.message);

      toast({
        title: error.response?.data?.error || error.message,
        status: "error",
      });
    }
  }

  const filtered =
    useMemo(() => {

      // return rows.filter(
      //   (item) => {

      //     const numero =
      //       String(
      //         item.numero_lideranca
      //       )
      //         .toLowerCase()
      //         .includes(
      //           numeroFilter.toLowerCase()
      //         );

      //     const nome =
      //       item.nome
      //         ?.toLowerCase()
      //         .includes(
      //           nomeFilter.toLowerCase()
      //         );

      //     const cpf =
      //       item.cpf
      //         ?.toLowerCase()
      //         .includes(
      //           cpfFilter.toLowerCase()
      //         );

      //     return (
      //       numero &&
      //       nome &&
      //       cpf
      //     );
      //   }
      // );

      return rows.filter((item) => {
        return (
          String(item.numero_lideranca ?? "")
            .toLowerCase()
            .includes(numeroFilter.toLowerCase()) &&
          String(item.nome ?? "")
            .toLowerCase()
            .includes(nomeFilter.toLowerCase()) &&
          String(item.cpf ?? "")
            .toLowerCase()
            .includes(cpfFilter.toLowerCase())
        );
      });
    }, [
      rows,
      numeroFilter,
      nomeFilter,
      cpfFilter
    ]);

  const columns = [

    {
      name: showNumero ? (

        <Input
          size="xs"
          autoFocus
          placeholder="Número..."
          value={numeroFilter}
          onChange={(e) =>
            setNumeroFilter(
              e.target.value
            )
          }
          onBlur={() => {

            if (
              !numeroFilter
            ) {
              setShowNumero(
                false
              );
            }
          }}
        />

      ) : (

        <HStack>

          <Text>
            Número
          </Text>

          <IconButton
            aria-label=""
            icon={<FiSearch />}
            size="xs"
            variant="ghost"
            onClick={() =>
              setShowNumero(
                true
              )
            }
          />

        </HStack>
      ),

      selector:
        (row: any) =>
          row.numero_lideranca,

      sortable: true,

      width: "180px"
    },

    {
      name: showNome ? (

        <Input
          size="xs"
          autoFocus
          placeholder="Nome..."
          value={nomeFilter}
          onChange={(e) =>
            setNomeFilter(
              e.target.value
            )
          }
          onBlur={() => {

            if (
              !nomeFilter
            ) {
              setShowNome(
                false
              );
            }
          }}
        />

      ) : (

        <HStack>

          <Text>
            Nome
          </Text>

          <IconButton
            aria-label=""
            icon={<FiSearch />}
            size="xs"
            variant="ghost"
            onClick={() =>
              setShowNome(
                true
              )
            }
          />

        </HStack>
      ),

      selector:
        (row: any) =>
          row.nome,

      sortable: true
    },

    {
      name: showCpf ? (

        <Input
          size="xs"
          autoFocus
          placeholder="CPF..."
          value={cpfFilter}
          onChange={(e) =>
            setCpfFilter(
              e.target.value
            )
          }
          onBlur={() => {

            if (
              !cpfFilter
            ) {
              setShowCpf(
                false
              );
            }
          }}
        />

      ) : (

        <HStack>

          <Text>
            CPF
          </Text>

          <IconButton
            aria-label=""
            icon={<FiSearch />}
            size="xs"
            variant="ghost"
            onClick={() =>
              setShowCpf(
                true
              )
            }
          />

        </HStack>
      ),

      selector:
        (row: any) =>
          row.cpf,

      sortable: true,

      width: "220px"
    },

    {
      name: "Ações",

      width: "180px",

      cell: (
        row: any
      ) => (

        <Flex gap={2}>

          <Tooltip
            label="Editar"
          >

            <IconButton
              aria-label=""
              colorScheme="blue"
              icon={<FiEdit />}
              onClick={() => {

                setEditing(
                  row
                );

                onOpen();
              }}
            />

          </Tooltip>

          <Tooltip
            label="Excluir"
          >

            <IconButton
              aria-label=""
              colorScheme="red"
              icon={
                <FiTrash2 />
              }
              onClick={() =>
                handleDelete(
                  row.id
                )
              }
            />

          </Tooltip>

        </Flex>
      )
    }
  ];

  return (

    <Box>

      <PageHeader
        title="Lideranças"
        onNew={() => {

          setEditing(null);

          onOpen();
        }}
      />

      <Flex
        justify="flex-end"
        mb={4}
      >

        <Button
          leftIcon={<FiX />}
          size="sm"
          variant="outline"
          onClick={() => {

            setNumeroFilter("");
            setNomeFilter("");
            setCpfFilter("");

            setShowNumero(false);
            setShowNome(false);
            setShowCpf(false);
          }}
        >
          Limpar filtros
        </Button>

      </Flex>

      <ContentCard>

        <DataTable
          columns={columns}
          data={filtered}
          progressPending={
            loading
          }
          pagination
          striped
          highlightOnHover
          responsive
          noDataComponent={
            <Box p={8}>
              Nenhuma liderança encontrada.
            </Box>
          }
        />

      </ContentCard>

      <FormModal
        isOpen={isOpen}
        onClose={onClose}
        onSave={handleSave}
        initialData={editing}
      />

    </Box>
  );
}